import BasePageApprove from '@/found/modules/table_page_approve';
import Table from './table.js';

export default {
  extends: BasePageApprove,
  components: {
    Table,
  },
};
